module.exports = __webpack_public_path__ + "img/product1.7a82776e.png";